module.exports = __webpack_public_path__ + "static/img/appstore.d723cbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/appstore.png
// module id = Rf8H
// module chunks = 0